"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyInput = void 0;
const react_1 = __importDefault(require("react"));
const merlin_currency_input_1 = require("@travelnest/merlin.currency-input");
const styled_1 = __importDefault(require("@emotion/styled"));
const theme_1 = __importDefault(require("../../styles/theme"));
const StyledCurrencyInputWrapper = styled_1.default.div `
	div {
		border-radius: ${theme_1.default.layout.radius.squared} !important;
		border-color: ${theme_1.default.colours.neutral.light} !important;
		color: ${theme_1.default.colours.text.darker} !important;
		transition: border-color ${theme_1.default.motion.transition.default};
		${({ valid }) => !valid && `
			color: ${theme_1.default.colours.error.default} !important;
			border-color: ${theme_1.default.colours.error.default} !important;
			background-color: ${theme_1.default.colours.error.tint} !important;
		`};
		${({ disabled }) => disabled && `
			background-color: ${theme_1.default.colours.background.default}  !important;
		`};
		&:hover,&:active,&:focus {
			border-color: ${theme_1.default.colours.neutral.dark} !important;
			${({ valid }) => !valid && `
				border-color: ${theme_1.default.colours.error.default} !important;
				color: ${theme_1.default.colours.error.default};
				background-color: ${theme_1.default.colours.error.tint};
			`};
		}
	}

	input {
		height: 2.6875rem !important;
		color: ${theme_1.default.colours.text.darker} !important;
		${({ valid }) => !valid && `
			color: ${theme_1.default.colours.error.default} !important;
			background-color: ${theme_1.default.colours.error.tint} !important;
		`};
		${({ disabled }) => disabled && `
			background-color: ${theme_1.default.colours.background.default}  !important;
		`};
		margin-right: ${theme_1.default.layout.radius.squared} !important;

		font-size: ${theme_1.default.typography.c3.fontSize} !important;
		line-height: ${theme_1.default.typography.c3.lineHeight} !important;
		font-weight: ${theme_1.default.typography.c3.fontWeight} !important;
		}

		-webkit-appearance: none;
	}

	div div.currency__label {
		font-size: ${theme_1.default.typography.c3.fontSize} !important;
		width: calc(70px - ${theme_1.default.layout.radius.squared}) !important;
		height: 2.6875rem !important;
		border-radius: 0 !important;
		margin-left: ${theme_1.default.layout.spacing.smallest} !important;
		padding-left: 0 !important;
	}
`;
const CurrencyInput = (props) => {
    const { handleChange } = props, rtiProps = __rest(props, ["handleChange"]);
    const onValueChangeHandler = (e) => {
        const inputNum = parseInt(e.target.value, 10);
        let propagateVal;
        if (e.target.value === '') {
            propagateVal = 0;
        }
        else {
            if (isNaN(inputNum)) {
                return;
            }
            propagateVal = inputNum;
        }
        if (handleChange) {
            handleChange(propagateVal);
        }
    };
    return react_1.default.createElement(StyledCurrencyInputWrapper, { valid: props.invalid !== undefined ? !props.invalid : true, disabled: props.disabled !== undefined ? props.disabled : false },
        react_1.default.createElement(merlin_currency_input_1.CurrencyInput, Object.assign({}, rtiProps, { type: "text", pattern: "[0-9]*", onChange: onValueChangeHandler })));
};
exports.CurrencyInput = CurrencyInput;
//# sourceMappingURL=CurrencyInput.js.map